jQuery(document).ready(function() {
  window.onpageshow = function(event) {
    if (event.persisted) {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  };
});

// window.addEventListener("manuallyAddedProducts", function(){
//     setTimeout(() => initHistoryScrollRestore(), 300);
//   });
  
//   loadProductsByUrlPage();
//   if(new URLSearchParams(window.location.search).get('page') == null) {
//     initHistoryScrollRestore();
//   }
// });

// function loadProductsByUrlPage() {
//   if (!$('body').hasClass('template-collection')) return;

//   const urlParams = new URLSearchParams(window.location.search);
//   const pageParam = parseInt(urlParams.get('page'), 10);
//   const sortBy = urlParams.get('sort_by');
//   const baseUrl = $('[data-coll-url]').val();
//   if (!baseUrl) return;

//   $('.js-load-more').on('click', function() {
//     var $this = $(this),
//         totalPages = parseInt($('[data-all-pages]').val()),
//         currentPage = parseInt($('[data-this-page]').val()),
//         datacollurl = window.location.href;

//     $this.attr('disabled', true);
//     var nextUrl = $('[data-next-link]').val();
//     var current_page_new = currentPage + 1;
//     var next_coll = currentPage + 2;
//     $this.addClass("btn-loading");

//     $.ajax({
//       url: nextUrl,
//       type: 'GET',
//       dataType: 'html',
//       success: function(responseHTML) {
//         console.log($(responseHTML).find('.collection-grid .grid-product').length);
//         // === Your existing logic ===
//         $('[data-next-link]').val('/search?options%5Bprefix%5D=last&page=' + next_coll + '&q=ab&type=product');
//         $('[data-this-page]').val(current_page_new);

//         $('.collection-grid').append($(responseHTML).find('.collection-grid').html());
//         $this.removeClass("btn-loading");
//         $('.stamped-badge-caption').addClass('custom-review');

//         var wdth = $('[data-coll-width]').val();
//         var ttlitemcount = $('[data-coll-itemcount]').val();
//         var perpage = $('[data-coll-perpage]').val();
//         var ttlload = current_page_new * perpage;
//         if (ttlitemcount < ttlload) { ttlload = ttlitemcount; }
//         wdth = (ttlload / ttlitemcount) * 100;
//         $('.progress_inner').css('width', wdth + '%');
//         $(".load_text").html('Showing ' + ttlload + ' of ' + ttlitemcount);

//         // === ✅ Update the URL ===
//         try {
//           var currentUrl = new URL(window.location.href);
//           currentUrl.searchParams.set('page', current_page_new);
//           window.history.pushState({ page: current_page_new }, '', currentUrl.toString());
//         } catch (err) {
//           console.error('Failed to update URL:', err);
//         }

//         // === ✅ Apply sorting if sort_by is in URL ===
//         if (sortBy) applyClientSideSort(sortBy);
//       },
//       complete: function() {
//         if (current_page_new < totalPages) {
//           $this.attr('disabled', false);
//         }
//         if (current_page_new >= totalPages) {
//           $('.load-more_wrap').remove();
//         }
//       }
//     });
//   });

//   // =====================================================
//   // === Load all previous pages if ?page= is present ====
//   // =====================================================
//   if (pageParam && pageParam > 1) {
//     let allProductsHTML = '';

//     function fetchPageProducts(pageNumber) {
//       const pageUrl = `${baseUrl}?page=${pageNumber}`;
//       return $.ajax({
//         url: pageUrl,
//         type: 'GET',
//         dataType: 'html'
//       }).then(responseHTML => {
//         const products = $(responseHTML).find('.collection-grid').html();
//         console.log($(responseHTML).find('.collection-grid .grid-product').length);
//         return products || '';
//       });
//     }

//     async function loadAllPreviousPages() {
//       for (let i = 1; i < pageParam; i++) {
//         try {
//           const html = await fetchPageProducts(i);
//           allProductsHTML += html;
//         } catch (err) {
//           console.error('Failed to load page', i, err);
//         }
//       }

//       if (allProductsHTML) {
//         window.dispatchEvent(new CustomEvent("manuallyAddedProducts", {
//           detail: {
//             message: "Products were manually added after sorting",
//             timestamp: Date.now()
//           }
//         }));
//         $('.collection-grid').prepend(allProductsHTML);
//       }

//       // Apply sorting if sort_by is present
//       if (sortBy) applyClientSideSort(sortBy);
//     }

//     loadAllPreviousPages();
//   }

//   // =====================================================
//   // === Sorting Logic (Shared by both parts) ===
//   // =====================================================
//   function applyClientSideSort(sortBy) {
//     const $grid = $('.collection-grid');
//     const $items = $grid.find('.grid-item').get();

//     function getPrice($el) {
//       const price = parseFloat($el.attr('data-product-price')) || 0;
//       return price;
//     }

//     function getCreatedDate($el) {
//       const rawDate = $el.attr('data-product-created-at');
//       return rawDate ? new Date(rawDate).getTime() : 0;
//     }

//     switch (sortBy) {
//       case 'price-ascending':
//         $items.sort((a, b) => getPrice($(a)) - getPrice($(b)));
//         break;
//       case 'price-descending':
//         $items.sort((a, b) => getPrice($(b)) - getPrice($(a)));
//         break;
//       case 'created-descending':
//         $items.sort((a, b) => getCreatedDate($(b)) - getCreatedDate($(a)));
//         break;
//       // Manual / best-selling can’t be replicated client-side
//       case 'manual':
//       case 'best-selling':
//       default:
//         return;
//     }

//     $grid.html($items);
//   }
// }

// function initHistoryScrollRestore() {
//   var storageKey = 'scrollPosition_' + window.location.pathname;
//   var shouldRestore = false;
//   var restored = false;

//   // Detect early navigation type (back_forward) if available
//   try {
//     var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
//     if (navEntries && navEntries.length && navEntries[0].type === 'back_forward') {
//       shouldRestore = true;
//     } else if (performance && performance.navigation && performance.navigation.type === 2) {
//       // fallback for older browsers: 2 ~= back_forward
//       shouldRestore = true;
//     }
//   } catch (e) {
//     // ignore detection errors
//   }

//   // If popstate fires -> user used back/forward
//   window.addEventListener('popstate', function() {
//     shouldRestore = true;
//     tryRestore();
//   }, false);

//   // pageshow covers bfcache restores; persisted === true means bfcache
//   window.addEventListener('pageshow', function(e) {
//     if (e && e.persisted) shouldRestore = true;
//     tryRestore();
//   }, false);

//   // Save the scroll position before leaving (normal navigation)
//   function saveScroll() {
//     try {
//       sessionStorage.setItem(storageKey, String(window.scrollY || 0));
//     } catch (err) {}
//   }
//   window.addEventListener('beforeunload', saveScroll, false);
//   window.addEventListener('pagehide', saveScroll, false);

//   // Hide document early if we already know we should restore (avoids jump)
//   // if (shouldRestore) {
//   //   document.documentElement.style.visibility = 'hidden';
//   // }

//   // Attempt to restore scroll if conditions met
//   function tryRestore() {
//     if (restored) return;
//     if (!shouldRestore) return;

//     var saved = null;
//     try {
//       saved = sessionStorage.getItem(storageKey);
//     } catch (e) { saved = null; }

//     if (saved === null) {
//       // nothing to restore, just reveal page
//       reveal();
//       return;
//     }

//     // Use double requestAnimationFrame to ensure rendering is ready,
//     // then scroll and reveal without visible jump
    
//     requestAnimationFrame(function() {
//       requestAnimationFrame(function() {
//         window.scrollTo(0, parseInt(saved, 10) || 0);
//         restored = true;
//         reveal();
//       });
//     });
//   }

//   function reveal() {
//     if (document.documentElement.style.visibility === 'hidden') {
//       document.documentElement.style.visibility = '';
//     }
//   }

//   // Run on DOM ready in case nav detection wasn't set earlier
//   tryRestore();
// }